import { DEFAULT_ANALYSIS_START_YEAR } from '@/features/analysis/_utils';
import { accountingType } from '@/features/master-table/models';
import { baseTextSearchCriteria } from '@/features/project/_models/filter-base-data';
import { DateRangeSchema, getCurrentFiscalYear, isPS } from '@/utils';
import {
  aggregationTargetTypeEnum,
  aggregationTypeEnum,
  analysisAxisEnum,
  analysisTargetEnum,
  implementationMethodEnum,
  projectCategoryEnum,
  sheetTypeEnum,
} from '@/utils/enum';
import { z } from 'zod';

const currentFiscalYear = getCurrentFiscalYear();

export const initialValueOfAnalysisSearchForm = {
  sheetType: sheetTypeEnum.enum.RS,
  analysisTarget: analysisTargetEnum.enum.expenditure,
  textSearchCriteria: baseTextSearchCriteria.options,
  fiscalYearRange:
    isPS() && currentFiscalYear === DEFAULT_ANALYSIS_START_YEAR
      ? [2024, 2024]
      : [currentFiscalYear - 1, currentFiscalYear],
  aggregationType: aggregationTypeEnum.enum.finalized,
  aggregationTargetType: aggregationTargetTypeEnum.enum.total,
  analysisAxis: analysisAxisEnum.enum.organization,
};

// 定義の順番がtagの並び順に影響
const AnalysisSearchSchema = z.object({
  analysisTarget: analysisTargetEnum,
  fiscalYearRange: DateRangeSchema.nullish(),
  sheetType: sheetTypeEnum,
  q: z.string().nullable(),
  isSearchTargetProjectName: z.boolean().nullable(),
  corporateNumber: z.string().nullable(),
  categories: projectCategoryEnum.array().nullable(),
  implementationMethods: implementationMethodEnum.array().nullable(),
  accountingType: accountingType.nullable(),
  accountingTypeIds: z.string().uuid().array().nullable(),
  projectNumbers: z.string().nullable(),
  period: DateRangeSchema.nullable(),
  // cascader項目
  nestedOrganizationIds: z.string().uuid().array().array().nullable(),
  nestedPolicyIds: z.string().uuid().array().array().nullable(),
  nestedOtherResponsibleOrganizationIds: z
    .string()
    .uuid()
    .array()
    .array()
    .nullable(),
  nestedExpenditureBudgetPurposeIds: z
    .string()
    .uuid()
    .array()
    .array()
    .nullable(),
  aggregationType: aggregationTypeEnum,
  aggregationTargetType: aggregationTargetTypeEnum,
  analysisAxis: analysisAxisEnum.nullable(),
});

export type AnalysisSearchFormType = z.infer<typeof AnalysisSearchSchema>;

type AnalysisSearchKeysType = keyof typeof AnalysisSearchSchema.shape;
const _AnalysisSearchKeys = Object.keys(
  AnalysisSearchSchema.shape,
) as AnalysisSearchKeysType[];
